import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { fmtPrice } from "./priceUtils";

/** Partner dashboard card — shown only while price changes are scheduled. */
export function PriceChangesCard() {
  const [up, setUp] = useState(null);
  useEffect(() => { api.get("/price-list").then(({ data }) => setUp(data.upcoming)).catch(() => setUp([])); }, []);
  if (!up?.length) return null;
  const rows = up.flatMap((b) => b.rows.map((r) => ({ ...r, date: b.effective_date })));
  const unread = up.filter((b) => !b.acknowledged).length;
  return (
    <Card className="mb-4 border-amber-200 bg-amber-50/60 p-4 shadow-sm" data-testid="dashboard-price-changes">
      <div className="flex items-center gap-2">
        <CalendarClock className="h-5 w-5 text-amber-600" />
        <div className="flex-1">
          <div className="text-sm font-semibold text-amber-900">{rows.length} upcoming price change{rows.length === 1 ? "" : "s"}</div>
          <div className="text-xs text-amber-800">Next on {up[0].effective_date}
            {unread === 0 ? <span className="ml-2 inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 className="h-3 w-3" /> Read</span> : ""}</div>
        </div>
        <Link to="/price-list?tab=upcoming" className="rounded-md bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-700"
              data-testid="dashboard-price-changes-open">View changes</Link>
      </div>
      {up[0].message && <p className="mt-2 line-clamp-2 text-xs italic text-amber-900" data-testid="dashboard-price-changes-message">{up[0].message}</p>}
      <ul className="mt-3 space-y-1 text-xs text-slate-700">
        {rows.slice(0, 3).map((r, i) => (
          <li key={i} className="flex gap-2"><span className="flex-1 truncate">{r.name}</span>
            <span className="tabular-nums">{r.removed ? "Removed" : `${r.old === null ? "On request" : fmtPrice(r.old)} → ${r.new_na ? "N/A" : r.new === null ? "On request" : fmtPrice(r.new)}`}</span>
            <span className="text-slate-400">{r.date}</span></li>
        ))}
        {rows.length > 3 && <li className="text-slate-400">+ {rows.length - 3} more</li>}
      </ul>
    </Card>
  );
}
